import { jsx as _jsx } from "react/jsx-runtime";
import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { fontRamp } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var FormattedText = /*#__PURE__*/ React.memo(function(param) {
    var text = param.text;
    var isSSR = useIsSSR();
    return !isSSR && (text === null || text === void 0 ? void 0 : text.length) ? /*#__PURE__*/ _jsx(StyleOverride, {
        children: /*#__PURE__*/ _jsx(SafelySetInnerHTML, {
            html: text,
            tag: "span"
        })
    }) : null;
});
// This component overrides the font weight of <b> tag to medium, since
// our texts use medium font weight for bold, but BE only send us <b> tag
var StyleOverride = styled.span.withConfig({
    componentId: "sc-cd421f27-0"
})([
    "b{font-weight:",
    ";}"
], fontRamp.fonts.paragraphSansMedium["font-weight"]);
